<template>
  <v-card color="grey lighten-4" style="width: 100%; height: 100%" flat tile>
    <DataCardList></DataCardList>
    <Header v-model="mini"></Header>
    <Navigation v-model="mini"></Navigation>
    <v-container fluid class="container_wrap">
      <AlertMessage></AlertMessage>
      <router-view :key="$route.path"></router-view>
    </v-container>
  </v-card>
</template>

<script>
  import AlertMessage from '../common/AlertMessage';
  import DataCard from "../common/DataCard";
  import Header from "@/components/layouts/includes/Header";
  import Navigation from "@/components/layouts/includes/Navigation";
  import DataCardList from "@/components/layouts/includes/DataCardList";

  export default {
    name: 'MainLayout',
    components: {
      AlertMessage,
      DataCard,
      Header,
      Navigation,
      DataCardList
    },
    data () {
      return {
        mini: true,
      }
    },
  }
</script>
<style lang="sass">
  .container_wrap
    position: relative
  header
    .office
      color: var(--v-primary-base)
    .span_for
      color: #ACC3CF
      font-size: 14px
      font-weight: 700
    .select_campaigns.v-text-field.v-text-field--solo:not(.v-text-field--solo-flat)>.v-input__control>.v-input__slot,
    .select_campaigns.v-text-field.v-text-field--solo:not(.v-text-field--solo-flat) > .v-input__control > .v-input__slot
      box-shadow: none

    .user-avatar
      border-radius: 100%
      width: 2.5em
      height: 2.5em
      margin-right: 10px

    .role
      padding: 5px 14px
      background-color: var(--v-tertiary-base)
      border-radius: 4px

    .nav
      display: block
      margin-top: 3px
      text-align: right

    .nav-item
      .dropdown-toggle
        white-space: nowrap
        padding: 0
        transition: all 0.5s ease

        span
          color: #fff
          font-size: 12px
          font-weight: 700
          letter-spacing: 0.5px
          text-decoration: none
          line-height: 1rem
          text-align: right

          &:hover
            color: #67E6F5
            cursor: pointer

        &::after
          display: inline-block
          margin-left: 0.255em
          vertical-align: middle
          content: ""
          border-top: 0.2em solid
          border-right: 0.2em solid transparent
          border-bottom: 0
          border-left: 0.2em solid transparent
          color: rgba(255, 255, 255, 0.5)

    span.user
      float: right

    .dropdown-menu
      text-align: right

    .dropdown-menu.dropdown-menu-right.show
      top: 5px !important

    .dropdown-item
      display: block
      width: 100%
      padding: 0.1rem 1rem
      clear: both
      font-size: 14px
      font-weight: 400
      color: #5c6489
      text-align: inherit
      white-space: nowrap
      background-color: transparent
      border: 0

      strong
        color: #3a3852
        font-size: 14px
        font-weight: 700

      &:hover, &:focus
        background-color: transparent

      a
        text-decoration: none

        span
          color: #3a3852
          font-size: 12px
          font-weight: 700
          letter-spacing: 1px
          text-decoration: none
          text-transform: uppercase

          &:hover
            color: var(--v-primary-base)
            cursor: pointer
  .item_menu
    position: relative
    .v-list-item__icon.color-secondary svg
      color: var(--v-secondary-base) !important
    .v-list-item__icon.color-primary svg
      color: var(--v-primary-base) !important
    &.v-list-item--active
      &::before
        opacity: 0 !important
      .v-list-item__content
        padding: 0px 0
        .v-list-item__title
          color: var(--v-primary-base) !important
          font-weight: 700
    .v-list-item__content
      .v-list-item__title
        color: #7F98A5
    &.disabled_color
      opacity: 0.2 !important
      color: #ACC3CF !important
    .logo
      position: absolute
      right: 90px
      top: 13px
      display: block
      width: 14px
      height: 15px


  .nav-group-line
    display: block
    width: 1px
    height: 100%
    background-color: #ACC3CF
    position: absolute
    top: -5px
    left: 27px

  .with-line
    margin-left: 56px !important

  .ps
    height: 100%
.v-application--is-ltr .v-list-item__action:first-child, .v-application--is-ltr .v-list-item__icon:first-child
  margin-right: 20px !important
</style>
